var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusevGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sev-icon muc",
    transform: "scale(.5) translate(75 83)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.2274 0L0.000366211 68.0298L40.2274 136.06H120.672L160.895 68.0298L120.672 0",
    fill: "#91268F"
  }))), /*#__PURE__*/React.createElement("text", {
    style: {
      color: "black",
      fontFamily: "arial",
      fontSize: 30,
      fontWeight: "bold"
    },
    fill: "white",
    x: 47,
    y: 85
  }, "SEV"), /*#__PURE__*/React.createElement("path", {
    d: "M67.15009,36.30219a30.9501,30.9501,0,1,1,0-.00023Z",
    style: {
      fill: "#353535"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.20544,17.19489A15.46416,15.46416,0,0,0,20.73172,32.65767c0,12.02845,15.47372,22.90019,15.47372,22.90019S51.66828,43.9541,51.66828,32.65767A15.46184,15.46184,0,0,0,36.20544,17.19489ZM36.20631,39.884a7.62,7.62,0,1,1,7.62-7.62A7.62873,7.62873,0,0,1,36.20631,39.884Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.88247,13.47554,59.22074,53.56676l-4.14229,3.87685L14.31052,17.19489Z",
    style: {
      fill: "#ec0016"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.20008,10.352A25.95009,25.95009,0,1,1,10.2499,36.302a25.97961,25.97961,0,0,1,25.95018-25.95m0-5a30.95009,30.95009,0,1,0,30.95,30.95019V36.302a30.95008,30.95008,0,0,0-30.95-30.95Z",
    style: {
      fill: "#353535"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusevGray);
export default __webpack_public_path__ + "static/media/busev-gray.7967e67568fde891fd19e87d11f70a38.svg";
export { ForwardRef as ReactComponent };